import { useApiStore } from '@/stores/apiStore';
import { TranslationApi } from '@/../generated-client/apis/TranslationApi';
import {
  GetMissingTranslationsRequest,
  GetMissingTranslationsResponse,
} from '../../generated-client/models';

export const INBOX_MESSAGE_OBJECT_TYPE = 'inbox_message' as const;
export const SUPPORT_LINK_OBJECT_TYPE = 'support_link' as const;

export type MissingTranslationObjectType =
  | typeof INBOX_MESSAGE_OBJECT_TYPE
  | typeof SUPPORT_LINK_OBJECT_TYPE;

let translationApi: TranslationApi | null = null;
let lastConfig: unknown = null;

function getTranslationApi(): TranslationApi {
  const { apiConfig } = useApiStore.getState();

  if (translationApi === null || lastConfig !== apiConfig) {
    translationApi = new TranslationApi(apiConfig);
    lastConfig = apiConfig;
  }

  return translationApi;
}

export const getMissingTranslations = async (request: {
  object_type: MissingTranslationObjectType;
  id: string;
}): Promise<GetMissingTranslationsResponse> => {
  const api = getTranslationApi();
  const getMissingTranslationsRequest: GetMissingTranslationsRequest = {
    object_type: request.object_type,
    id: request.id,
  };
  return await api.apiTranslationGetMissingTranslationsPost({
    getMissingTranslationsRequest,
  });
};
